export type ApiEnvelope<T> = {
  success?: boolean;
  data?: T;
  message?: string | string[];
  error?: { message?: string | string[]; code?: string };
};

export type ApiErrorKind =
  | 'auth'
  | 'permission'
  | 'validation'
  | 'network'
  | 'server'
  | 'unknown';

export class ApiError extends Error {
  constructor(
    public readonly kind: ApiErrorKind,
    message: string,
    public readonly status?: number,
    public readonly raw?: unknown,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

export function extractMessage(body: unknown): string {
  if (!body || typeof body !== 'object') return 'Request failed';
  const b = body as ApiEnvelope<unknown>;
  const m = b.error?.message ?? b.message;
  if (Array.isArray(m)) return m.join('\n');
  return typeof m === 'string' && m.length > 0 ? m : 'Request failed';
}

/** Unwrap the `{ success, data }` envelope when present; otherwise return as-is. */
export function unwrap<T>(body: unknown): T {
  if (body && typeof body === 'object' && 'success' in (body as object)) {
    const e = body as ApiEnvelope<T>;
    if (e.success === false) throw new ApiError('server', extractMessage(e));
    return (e.data as T) ?? (body as T);
  }
  return body as T;
}
